import { prop } from 'datx';

import { BaseModel } from './BaseModel';

export class Article extends BaseModel {
  public static type = 'articles';

  @prop
  public title: string;

  @prop
  public url: string;
}
